import { format } from 'date-fns';

/**
 * Parse a date string or Date object to a local Date object
 * Handles ISO strings and ensures dates are interpreted in local time
 */
export function parseLocalDate(dateInput: string | Date): Date {
  if (dateInput instanceof Date) {
    return dateInput;
  }

  // If it's an ISO string like "2025-10-04T12:00:00.000Z"
  if (dateInput.includes('T')) {
    // Extract just the date part (YYYY-MM-DD)
    const datePart = dateInput.split('T')[0];
    const [year, month, day] = datePart.split('-').map(Number);
    // Create date in local timezone
    return new Date(year, month - 1, day);
  }

  // If it's already in YYYY-MM-DD format
  const [year, month, day] = dateInput.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Format a date for display
 */
export function formatShowDate(dateInput: string | Date, formatString: string = 'EEEE, MMMM d, yyyy'): string {
  const date = parseLocalDate(dateInput);
  return format(date, formatString);
}

/**
 * Check if a show date is in the future
 */
export function isUpcoming(dateInput: string | Date): boolean {
  const showDate = parseLocalDate(dateInput);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset to start of day
  return showDate >= today;
}

/**
 * Sort shows by date
 */
export function sortShowsByDate<T extends { date: string | Date }>(shows: T[]): T[] {
  return [...shows].sort((a, b) => {
    const dateA = parseLocalDate(a.date);
    const dateB = parseLocalDate(b.date);
    return dateA.getTime() - dateB.getTime();
  });
}
